import { ChangeDetectorRef, Component, OnInit, inject} from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { SidebarModule } from 'primeng/sidebar';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { HomeContainerComponent } from '../../home/home-container/home-container.component';
import { Store } from '@ngrx/store';
import { BaseState } from '../../reducers';
import { selectUserState } from '../../users/store/user.selector';
import { filter, interval, map } from 'rxjs';
import { StripeHandlerService } from '../../services/stripe-handler.service';

export type ScrollToPositions = "features" | "reviews" | "pricing" | "faq" | "stats"

@Component({
  selector: 'app-menu-bar',
  standalone: true,
  imports: [
    MenubarModule,
    ButtonModule,
    SidebarModule,
    NgTemplateOutlet,
    AsyncPipe
  ],
  templateUrl: './menu-bar.component.html',
  styleUrl: './menu-bar.component.scss'
})
export class MenuBarComponent implements OnInit{
  firebaseAuth = inject(Auth)
  store = inject(Store<BaseState>)
  stripe = inject(StripeHandlerService)

  activeSub$ = this.store.select(selectUserState).pipe(
    map(x => !!x?.activeSubscription)
  )
  credits$ = this.store.select(selectUserState).pipe(
    map(x => x?.credits)
  )
  isInGroup$ = this.store.select(selectUserState).pipe(
    map(x => x?.groupId)
  )

  userIsLoggedIn = false
  sidebarVisible = false
  awaitStripePortal = false
  couponCodeVisible = true
  couponCodeEndTime = new Date('2025-04-20T23:59:59')

  timeLeft$ = interval(100).pipe(
    map(() => {
      const diff = (this.couponCodeEndTime.getTime() - new Date().getTime()) / 1000
      const days = Math.floor(diff / (60 * 60 * 24)).toString().padStart(2, "0")
      const hours = Math.floor((diff / (60 * 60)) % 24).toString().padStart(2, "0")
      const minutes = Math.floor((diff / 60) % (60)).toString().padStart(2, "0")
      const seconds = Math.floor(diff % (60)).toString().padStart(2, "0")
      return `${days} days, ${hours} hours, ${minutes} mins, ${seconds} seconds`
    })
  )

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.router.events.pipe(
      filter((_) => Date.now() < this.couponCodeEndTime.getTime())
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.url.concat(event.urlAfterRedirects)
        if (url.includes("home") || url.includes("market") || url.includes("docs") || url.includes("my-renders")) {
          this.couponCodeVisible = true
        }
        else {
            console.log(event)
          this.couponCodeVisible = false
        }
      }
    })
  }

  ngOnInit(): void {
    this.userIsLoggedIn = this.firebaseAuth.currentUser !== null
    this.firebaseAuth.onAuthStateChanged((user) => {
      this.userIsLoggedIn = user !== null
    })
  }

  login() {
    this.router.navigate(['/login']);
  }
  logout(){
    this.firebaseAuth.signOut().then(() => {
      this.router.navigate(['/home']);
    })
  }

  home() {
    this.router.navigate(['/home']);
  }

  logButton() {
    if (this.userIsLoggedIn) {
      this.logout()
    }
    else {
      this.login()
    }
    this.sidebarVisible = false
  }

  navigateAndScrollTo(position: ScrollToPositions) {
    if (this.route.component === HomeContainerComponent) {
      this.scrollTo(position)
    }
    else {
      this.router.navigate(["home"]).then(_ => {
        setTimeout(()=> this.scrollTo(position), 100)
      })
    }
  }

  scrollTo(position: ScrollToPositions) {
    let element = document.getElementById(position)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    this.sidebarVisible = false
  }

  redirectToPortal() {
    this.stripe.createPortalSession()
    this.awaitStripePortal = true
  }
}
